import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import CorazonIcon from "_+_Portal/assets/images/generico/CorazonIcon";
import InjectionIcon from "_+_Portal/assets/images/generico/InjectionIcon";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  BtnContainerSelectorCircuito,
  ContianerSelectorCircuito,
} from "./localStyle";
import {
  setCircuito,
  setPaso,
} from "_+_Portal/_-_Autocheckin/context/action/paso";
import { OrderTurnos, OrderTurnosLabo } from "../PagesFun";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";

const SelectorCircuito = () => {
  //#region --------- context ---------------
  const {
    pasoDispatch,
    textosAutoCheckinState,
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    ubicacionState,
  } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const [dataLoading, setDataLoading] = useState(true);
  const [laboPresent, setLaboPresent] = useState(false);
  const [turnoPresent, setTurnoPresent] = useState(false);
  const [laboPresentesList, setLaboPresentesList] = useState(false);

  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
      ?.nombre
    : authState?.auth?.data?.paciente?.nombre ?? "";

  let config = localStorage.getItem("config");
  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(config) ?? {};
  } catch (e) {
    parsedConfig = {};
  }
  let opcMasInfoHome = parsedConfig?.opcMasInfoHome;
  let opcAutoCheckInLabo = parsedConfig?.opcAutoCheckInLabo;
  let opcConsultaMedica = parsedConfig?.opcConsultaMedica;
  let opcEstudios = parsedConfig?.opcEstudios;

  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  const minutosToleranciaRecepcion = parsedConfig?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = parsedConfig?.minRecepcionVariosTurnos;
  const coordenadas = ubicacionState?.ubicacion?.data;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------

  const handleTurno = () => {
    if (turnoPresent) {
      setPaso("TurnosRecepionados")(pasoDispatch);
    } else {
      setCircuito("turnos")(pasoDispatch);
      setPaso("UbicacionSinTurno")(pasoDispatch);
      // setPaso("TurnosDelDia")(pasoDispatch);
    }
  };
  const handleLaboratorio = () => {
    setCircuito("labo")(pasoDispatch);
    if (laboPresent) {
      setTurnosSeleccionado(laboPresentesList)(turnosSeleccionadosDispatch);
      setPaso("TurnosConPresente")(pasoDispatch);
    } else {
      setCircuito("turnosLabo")(pasoDispatch);
      setPaso("UbicacionSinTurno")(pasoDispatch);
      // setPaso("TurnosDelDiaLabo")(pasoDispatch);
    }
  };

  const checkTurnosPresentes = (data) => {
    if (data?.length > 0) {
      const dataLabo = data.filter((turno) => turno.idProtocolo);
      const dataTurno = data.filter((turno) => turno.idProtocolo === 0);
      const laboOrdenados = OrderTurnosLabo(
        dataLabo,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        coordenadas
      );
      const turnosOrdenados = OrderTurnos(
        dataTurno,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        false,
        coordenadas
      );
      const turnosPresentes = turnosOrdenados.filter((turno) => turno.presente);
      const laboPresentes = laboOrdenados.filter(
        (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio"
      );
      if (laboPresentes.length > 0) {
        setLaboPresentesList(laboPresentes);
        setLaboPresent(true);
      }
      if (turnosPresentes.length > 0) {
        setTurnoPresent(true);
      }
    }
    setDataLoading(false);
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    checkTurnosPresentes(turnosAutoCheckInState?.turnosAutoCheckIn?.data);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={dataLoading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      {dataLoading ? (
        ""
      ) : (
        <LayoutPasos
          title={`¡Hola ${camelize(pacienteNombre)}!`}
          subtitle="¿En que podemos ayudarte hoy?"
        >
          <ContianerSelectorCircuito>
            <BtnContainerSelectorCircuito
              initial={{ opacity: 0, y: +100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.4 }}
              $opcMasInfoHome={opcMasInfoHome}>
              {opcConsultaMedica && (
                <BtnLink
                  Icon={<ConsultaIcon color={"var(--color-primary)"} />}
                  type={turnoPresent ? "GREEN" : "NORMAL"}
                  title={turnoPresent ? "CONSULTA PRESENTES" : "CONSULTA MÉDICA"}
                  onclick={handleTurno}
                />
              )}
              {opcEstudios && (
                <BtnLink
                  Icon={<CorazonIcon color={"var(--color-primary)"} />}
                  type={turnoPresent ? "GREEN" : "NORMAL"}
                  title={turnoPresent ? "ESTUDIOS PRESENTES" : "ESTUDIO"}
                  onclick={handleTurno}
                />
              )}
              {opcAutoCheckInLabo && (
                <BtnLink
                  Icon={<InjectionIcon color={"var(--color-primary)"} />}
                  type={laboPresent ? "GREEN" : "NORMAL"}
                  title={laboPresent ? "LABORATORIO PRESENTES" : "LABORATORIO"}
                  onclick={handleLaboratorio}
                />
              )}
            </BtnContainerSelectorCircuito>
          </ContianerSelectorCircuito>
        </LayoutPasos>
      )}
    </>
  );
};

export default SelectorCircuito;
